import React, { useState, useEffect, useCallback, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./SuperAdminDashboard.css";
import {viewAllAdmins,updateAdminStatus} from "../Apis/SuperadminApis";
import {fetchDashboardSummary, fetchTeamRequests, fetchNotifications} from "../Apis/AdminApis";
import { useNavigate, useLocation } from "react-router-dom";
import pavamanLogo from "../images/drone.png";
import PopupMessage from "../PopupMessage/PopupMessage";
import { FiSearch, FiFilter, FiCheck, FiX, FiLock, FiUnlock, FiUserCheck, FiUserX } from "react-icons/fi";
import { FaCheck, FaTimes, FaBan, FaPlay } from "react-icons/fa";
// REMOVE THIS LINE: import SuperAdminNotificationBell from "./SuperAdminNotificationBell";
// ADD THESE IMPORTS:
import NotificationBell from "../Admin/NotificationBell";
import NotificationsPage from "../Admin/NotificationsPage";
import useDashboardSSE from "../../src/hooks/useDashboardSSE";

const SuperAdminDashboard = () => {
const navigate = useNavigate();
const location = useLocation();
const [timeRange, setTimeRange] = useState(() => {
  return localStorage.getItem("superAdminDashboardTimeRange") || "week";
});
const [showMobileFilters, setShowMobileFilters] = useState(false);
const [customDateRange, setCustomDateRange] = useState(() => {
const savedRange = localStorage.getItem("superAdminDashboardCustomDateRange");

  return savedRange
    ? JSON.parse(savedRange)
    : {
        start_date: "",
        end_date: "",
      };
});
const [appliedCustomRange, setAppliedCustomRange] = useState(() => {
  const savedRange = localStorage.getItem("superAdminDashboardCustomDateRange");
  return savedRange
    ? JSON.parse(savedRange)
    : {
        start_date: "",
        end_date: "",
      };
});
  const [isLoading, setIsLoading] = useState(true);
const [stats, setStats] = useState({
  totalAdmins: 0,
  notSubmittedAdmins: 0,
  activeAdmins: 0,
  inactiveAdmins: 0,
  rejectedAdmins: 0,  
  pendingAdmins: 0,
  totalPilots: 0,
  totalDrones: 0,
  totalAcres: 0,
  weeklyAcres: 0,
  monthlyAcres: 0,
  activeMissions: 0,
  totalMissions: 0,
  totalMissionHours: 0,
  totalSprayLiters: 0
});
  
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [companyPilots, setCompanyPilots] = useState([]);
  const [companyAdmins, setCompanyAdmins] = useState([]);
  const [companyActivity, setCompanyActivity] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [notificationsData, setNotificationsData] = useState({
  unread_count: 0,
  notifications: [],
});
  const [selectedViewAdmin, setSelectedViewAdmin] = useState(null); 
  const firstLoad = useRef(true);
const timeRangeRef = useRef(timeRange);
const appliedCustomRangeRef = useRef(appliedCustomRange);
  const displayedCompanies = filteredCompanies.slice(0, 10);
  const hasMoreAdmins = filteredCompanies.length > 10;

useEffect(() => {
  localStorage.setItem("superAdminDashboardTimeRange", timeRange);
  timeRangeRef.current = timeRange;
}, [timeRange]);

// ✅ Save the applied range, not the editing range
useEffect(() => {
  localStorage.setItem(
    "superAdminDashboardCustomDateRange",
    JSON.stringify(appliedCustomRange)
  );
  appliedCustomRangeRef.current = appliedCustomRange;
}, [appliedCustomRange]);
  const effectiveAdminId = selectedViewAdmin?.id || null;
  
useEffect(() => {
  if (timeRange === "custom") {
    // ✅ Only load when appliedCustomRange has valid dates
    if (!appliedCustomRange.start_date || !appliedCustomRange.end_date) {
      return;
    }
    loadDashboardData();
  } else {
    loadDashboardData();
  }
}, [timeRange, appliedCustomRange.start_date, appliedCustomRange.end_date]);

useEffect(() => {
  const loadNotificationCount = async () => {
    try {
      const response = await fetchNotifications("count");

      if (response?.error) {
        console.error("Notifications error:", response.error);
        setNotificationsData((prev) => ({ ...prev, unread_count: 0 }));
        return;
      }

      setNotificationsData((prev) => ({
        ...prev,
        unread_count: Number(response?.unread_count || 0),
      }));
    } catch (error) {
      console.error("❌ Failed to load notification count:", error);
      setNotificationsData((prev) => ({ ...prev, unread_count: 0 }));
    }
  };

  loadNotificationCount();
}, []);

const loadDashboardSummaryCards = useCallback(async (currentTimeRange, currentAppliedRange) => {
    try {
      let payload = {};
      
     if (currentTimeRange === "custom") {
  if (!currentAppliedRange.start_date || !currentAppliedRange.end_date) {
    console.warn("Custom date range not fully selected");
    return;
  }
  payload = {
    filter_type: "custom",
    start_date: currentAppliedRange.start_date,
    end_date: currentAppliedRange.end_date
  };
}else {
        const today = new Date().toISOString().split("T")[0];
        payload = {
          filter_type: currentTimeRange,
          date: today
        };
      }
      
      const response = await fetchDashboardSummary(payload);
if (response?.error === "Unauthorized") {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  localStorage.clear();

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return false;
}
      
      if (response && !response.error) {
 let summaryData = null;
if (response.dashboard?.admin_companies?.cards) {
  summaryData = response.dashboard.admin_companies.cards;
} 
else if (response.dashboard?.superadmin_company?.cards) {
  summaryData = response.dashboard.superadmin_company.cards;
} 
else if (response.cards) {
  summaryData = response.cards;
}
        
        if (summaryData) {
          console.log("Dashboard summary data:", summaryData); 
              setStats(prevStats => ({
        ...prevStats,
        totalAdmins: summaryData.total_admins || 0,
        totalAcres: summaryData.total_acres || 0,
        activeMissions: summaryData.active_missions || 0,
        totalPilots: summaryData.total_pilots ?? prevStats.totalPilots,
        totalDrones: summaryData.total_drones ?? prevStats.totalDrones,
        totalMissions: summaryData.total_missions || 0,
        totalMissionHours: summaryData.total_mission_hours || 0,
        totalSprayLiters: summaryData.total_spray_liters || 0
      }));
        }
        return true;
      }
    } catch (err) {
      console.error("Failed to load dashboard summary:", err);
      if (
      err?.response?.status === 401 ||
      err?.message?.includes("Unauthorized")
    ) {

      setPopupMessage("Session expired, redirecting to login page");
      setPopupType("error");
      setPopupOpen(true);

      localStorage.clear();

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      return false;
    }
    }
  }, []);

const loadDashboardData = useCallback(async () => {
  try {
    setIsLoading(true);
    const sessionValid = await loadDashboardSummaryCards(
      timeRangeRef.current,
      appliedCustomRangeRef.current
    );

if (sessionValid === false) {
  return;
}
    const [adminsData] = await Promise.all([
      viewAllAdmins({ action: "admin" }),
    ]);
    if (adminsData?.error === "Unauthorized") {

  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  localStorage.clear();

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
    
    const adminList = adminsData?.data || [];
const notSubmittedAdmins = adminList.filter(a => Number(a.approval) === 0).length;
const pendingAdmins = adminList.filter(a => Number(a.approval) === 1).length;
const activeAdmins = adminList.filter(a => Number(a.approval) === 2 && Number(a.status) === 1).length;
const inactiveAdmins = adminList.filter(a => Number(a.approval) === 2 && Number(a.status) === 0).length;
const rejectedAdmins = adminList.filter(a => Number(a.approval) === 3).length;

      setStats(prevStats => ({
        ...prevStats,
        notSubmittedAdmins,
        pendingAdmins,
        activeAdmins,
        inactiveAdmins,
        rejectedAdmins, 
      }));
    
    setCompanies(adminList);
    filterCompanies(adminList, searchTerm, statusFilter);
    
  } catch (err) {
    console.error("Failed to load dashboard data:", err);
    setPopupMessage("Failed to load dashboard data. Please try again.");
    setPopupType("error");
    setPopupOpen(true);
  } finally {
    setIsLoading(false);
    firstLoad.current = false;
  }
}, [loadDashboardSummaryCards, searchTerm, statusFilter]);

const filterCompanies = (companiesList, search, status) => {
  let filtered = [...companiesList];
  
  if (search) {
    filtered = filtered.filter(company => 
      company.name?.toLowerCase().includes(search.toLowerCase()) ||
      company.email?.toLowerCase().includes(search.toLowerCase()) ||
      company.contact_name?.toLowerCase().includes(search.toLowerCase())
    );
  }
  
  if (status !== 'all') {
  if (status === 'active') {
    filtered = filtered.filter(c => c.approval === 2 && c.status === 1);
  } else if (status === 'inactive') {
    filtered = filtered.filter(c => c.approval === 2 && c.status === 0);
  } else if (status === 'rejected') {
    filtered = filtered.filter(c => c.approval === 3);
  } else if (status === 'pending') {
    filtered = filtered.filter(c => c.approval === 1);
  } else if (status === 'not-submitted') {
    filtered = filtered.filter(c => c.approval === 0);
  }
}
  
  setFilteredCompanies(filtered);
};

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    filterCompanies(companies, term, statusFilter);
  };

 const handleStatusFilter = (status) => {
  setStatusFilter(status);
  filterCompanies(companies, searchTerm, status);
};

  const handleCompanyClick = async (company) => {
    setSelectedCompany(company);
    setShowCompanyModal(true);
  
    try {
      const [pilotsData, adminsData] = await Promise.all([
        fetchTeamRequests({ admin_id: company.id }),
        viewAllAdmins({ action: "admin" })
      ]);
         // ✅ Check unauthorized AFTER API response
    if (
      pilotsData?.error === "Unauthorized" ||
      adminsData?.error === "Unauthorized"
    ) {
      setPopupMessage("Session expired, redirecting to login page");
      setPopupType("error");
      setPopupOpen(true);

      localStorage.clear();

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      return;
    }

      
      setCompanyPilots(pilotsData?.pilots || []);
  setCompanyAdmins(adminsData?.data || []);
      setCompanyActivity([
        { action: "Company created", date: company.created_on, user: "System" },
        { action: "Admin added", date: company.created_on, user: "Super Admin" }
      ]);
      
    } catch (err) {
      console.error("Failed to load company details:", err);
      setPopupMessage("Failed to load company details.");
      setPopupType("error");
      setPopupOpen(true);
    }
  };

  const handleUpdateStatus = async (action) => {
    try {
      setIsUpdating(true);
      
      const response = await updateAdminStatus({
        email: selectedCompany.email,
        action: action
      });
      
     if (
  response?.error === "Unauthorized" ||
  response?.error === "Unauthorized. Please login."
) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  localStorage.clear();

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}

if (response.error) {
  setPopupMessage(response.error);
  setPopupType("error");
  setPopupOpen(true);
} else if (response.message) {
  setPopupMessage(response.message);
  setPopupType("success");
  setPopupOpen(true);

  await loadDashboardData();

  setShowCompanyModal(false);
  setSelectedCompany(null);
}
    } catch (err) {
      console.error("Failed to update status:", err);
      setPopupMessage("Failed to update company status");
      setPopupType("error");
      setPopupOpen(true);
    } finally {
      setIsUpdating(false);
      setShowActionModal(false);
      setActionType(null);
    }
  };

  const openActionModal = (type) => {
    setActionType(type);
    setShowActionModal(true);
  };

  const closeActionModal = () => {
    setShowActionModal(false);
    setActionType(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return 'Invalid Date';
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return 'Invalid Date';
    }
  };

const handleTimeRangeChange = (range) => {
  if (range === timeRange) return;
  
  if (range === "custom") {
    setTimeRange("custom");
    // ✅ Reset appliedCustomRange when switching to custom
    setAppliedCustomRange({
      start_date: "",
      end_date: ""
    });
    return;
  }

  setIsLoading(true);
  setTimeRange(range);
};

const getStatusBadge = (approval, status) => {
  if (approval === 0) {
    return { text: 'Not Submitted', color: '#95a5a6', bg: '#f3f4f6', icon: '📝' };
  } else if (approval === 1) {
    return { text: 'Pending', color: '#f39c12', bg: '#fef3c7', icon: '⏳' };
  } else if (approval === 2 && status === 1) {
    return { text: 'Active', color: '#00B894', bg: '#d1fae5', icon: '✓' };
  } else if (approval === 2 && status === 0) {
    return { text: 'Inactive', color: '#95a5a6', bg: '#f3f4f6', icon: '○' };
  } else if (approval === 3) {
    return { text: 'Rejected', color: '#e74c3c', bg: '#fee2e2', icon: '✗' };  
  }
  return { text: 'Unknown', color: '#95a5a6', bg: '#f3f4f6', icon: '?' };
};

const getActionButtons = (company) => {
  const status = getStatusBadge(company.approval, company.status);
  if (company.approval === 1) {
    return (
      <div className="sa-action-buttons">
        <button className="sa-btn-approve" onClick={() => {
          setSelectedCompany(company);
          openActionModal('approve');
        }}>
          <FaCheck /> Approve
        </button>
        <button className="sa-btn-reject" onClick={() => {
          setSelectedCompany(company);
          openActionModal('reject');
        }}>
          <FaTimes /> Reject
        </button>
      </div>
    );
  } 

  else if (company.approval === 2) {
    return (
      <div className="sa-action-buttons">
        <button className="sa-btn-reject" onClick={() => {
          setSelectedCompany(company);
          openActionModal('reject');
        }}>
          <FaTimes /> Reject
        </button>
      </div>
    );
  } 
  
  else if (company.approval === 3) {
    return (
      <div className="sa-action-buttons">
        <button className="sa-btn-approve" onClick={() => {
          setSelectedCompany(company);
          openActionModal('approve');
        }}>
          <FaCheck /> Approve
        </button>
      </div>
    );
  }
  
  return null;
};

const stableLoadDashboardData = useCallback(() => {
  loadDashboardData();
}, [loadDashboardData]);

// useDashboardSSE({
//   fetchDashboard: stableLoadDashboardData,
//   role: "superadmin",
// });

// ✅ Render notifications page only AFTER all hooks have been called
if (location.pathname === "/superadmin/notifications") {
  return <NotificationsPage role="superadmin" />;
}

 if (isLoading) {
  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <div className="dashboard-content">
        <div className="custom-loading-container">
          <img src={pavamanLogo} alt="Loading" className="spinning-logo" />
          <p className="loading-text">
            {firstLoad.current
              ? "Loading dashboard data..."
              : "Updating dashboard filter..."}
          </p>
        </div>
      </div>
    </div>
  );
}

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Super Admin Dashboard</h1>
            <p className="dashboard-subtitle">Manage all vendor companies and fleet operations</p>
          </div>
        <div className="header-right">
  <div className="date-range">
    <span className="current-date">{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
    <div className="ad-time-buttons">
      {['day','week','month','year','custom'].map(range => (
        <button
          key={range}
          className={`ad-time-btn ${timeRange === range ? 'active' : ''}`}
          onClick={() => handleTimeRangeChange(range)}
        >
          {range.charAt(0).toUpperCase() + range.slice(1)}
        </button>
      ))}
    </div>
    
    {timeRange === 'custom' && (
      <div className="custom-date-range">
        <input 
          type="date" 
          className="date-input"
          value={customDateRange.start_date}
          onChange={(e) => setCustomDateRange({...customDateRange, start_date: e.target.value})}
          placeholder="Start Date"
        />
        <span className="date-separator">to</span>
        <input 
          type="date" 
          className="date-input"
          value={customDateRange.end_date}
          onChange={(e) => setCustomDateRange({...customDateRange, end_date: e.target.value})}
          placeholder="End Date"
        />
        <button 
          className="apply-date-btn"
          onClick={() => {
            if (customDateRange.start_date && customDateRange.end_date) {
              setAppliedCustomRange({
                start_date: customDateRange.start_date,
                end_date: customDateRange.end_date
              });
              setIsLoading(true);
            } else {
              setPopupMessage("Please select both start and end dates");
              setPopupType("error");
              setPopupOpen(true);
            }
          }}
        >
          Apply
        </button>
      </div>
    )}
  </div>
  {/* ✅ REPLACE SuperAdminNotificationBell with shared NotificationBell */}
  <NotificationBell
    notificationsData={notificationsData}
    setNotificationsData={setNotificationsData}
    role="superadmin"
  />
</div>
        </div>

        <div className="sa-stats-grid">
          <div className="sa-stat-card">
            <div className="sa-stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
              <span className="icon">🏢</span>
            </div>
            <div className="sa-stat-content">
              <p className="sa-stat-label">Total Admins</p>
              <h3 className="sa-stat-value">{stats.totalAdmins}</h3>
            </div>
          </div>

          <div className="sa-stat-card">
            <div className="sa-stat-icon" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
              <span className="icon">👨‍✈️</span>
            </div>
            <div className="sa-stat-content">
              <p className="sa-stat-label">Total Pilots</p>
              <h3 className="sa-stat-value">{stats.totalPilots}</h3>
            </div>
          </div>

          <div className="sa-stat-card">
            <div className="sa-stat-icon" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
              <span className="icon">
                <img src={require("../images/drone image.png")} alt="Drone" className="drone-icon" />
              </span>
            </div>
            <div className="sa-stat-content">
              <p className="sa-stat-label">Total Drones</p>
              <h3 className="sa-stat-value">{stats.totalDrones}</h3>
            </div>
          </div>

          <div className="sa-stat-card">
            <div className="sa-stat-icon" style={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' }}>
              <span className="icon">🌾</span>
            </div>
            <div className="sa-stat-content">
              <p className="sa-stat-label">Total Acres</p>
              <h3 className="sa-stat-value">{stats.totalAcres.toLocaleString()}</h3>
            </div>
          </div>

          <div className="sa-stat-card">
            <div className="sa-stat-icon" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
              <span className="icon">🔄</span>
            </div>
            <div className="sa-stat-content">
              <p className="sa-stat-label">Active Missions</p>
              <h3 className="sa-stat-value">{stats.activeMissions}</h3>
            </div>
          </div>
        </div>

    <div className="sa-filter-section">
  <div className="sa-search-wrapper">
    <FiSearch className="sa-search-icon" />
    <input
      type="text"
      placeholder="Search by company name, email..."
      value={searchTerm}
      onChange={handleSearch}
      className="sa-search-input"
    />
    <button 
      className="sa-mobile-filter-toggle"
      onClick={() => setShowMobileFilters(!showMobileFilters)}
    >
      <FiFilter /> Filters
    </button>
  </div>

 <div className={`sa-filters ${showMobileFilters ? 'mobile-open' : ''}`}>
  <button
    className={`sa-filter-btn ${statusFilter === "all" ? "active" : ""}`}
    onClick={() => {
      handleStatusFilter("all");
      setShowMobileFilters(false);
    }}
  >
    All ({companies.length})
  </button>
  <button
    className={`sa-filter-btn ${statusFilter === "active" ? "active" : ""}`}
    onClick={() => {
      handleStatusFilter("active");
      setShowMobileFilters(false);
    }}
  >
    Active ({stats.activeAdmins})
  </button>
  <button
  className={`sa-filter-btn ${statusFilter === "rejected" ? "active" : ""}`}
  onClick={() => {
    handleStatusFilter("rejected");
    setShowMobileFilters(false);
  }}
>
   Rejected ({stats.rejectedAdmins})
</button>
  <button
    className={`sa-filter-btn ${statusFilter === "pending" ? "active" : ""}`}
    onClick={() => {
      handleStatusFilter("pending");
      setShowMobileFilters(false);
    }}
  >
    Pending ({stats.pendingAdmins})
  </button>
  <button
    className={`sa-filter-btn ${statusFilter === "not-submitted" ? "active" : ""}`}
    onClick={() => {
      handleStatusFilter("not-submitted");
      setShowMobileFilters(false);
    }}
  >
    Not Submitted ({stats.notSubmittedAdmins})
  </button>
</div>
</div>
        <div className="tr-table-container">
          <table className="tr-table">
            <thead className="tr-thead">
              <tr>
                <th>Company</th>
                <th>Contact</th>
                <th>Status</th>
                <th>Pilots</th>
                <th>Drones</th>
                <th>Last Activity</th>
                <th>Actions</th>
              </tr>
            </thead>
        <tbody>
  {displayedCompanies.map((company, index) => {
    const status = getStatusBadge(company.approval, company.status);
    return (
      <tr key={company.id} className="sa-table-row">
        <td className="sa-company-cell">
          <div className="sa-company-info">
            {company.logo_url ? (
              <img
                src={company.logo_url}
                alt={company.name}
                className="sa-company-logo sa-clickable-logo"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/superadmin/company/${company.id}`);
                }}
                title="Click to view company details"
              />
            ) : (
              <div 
                className="sa-company-logo-placeholder sa-clickable-logo"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/superadmin/company/${company.id}`);
                }}
                title="Click to view company details"
              >
                🏢
              </div>
            )}
            <div>
              <div className="sa-company-name">{company.name || "N/A"}</div>
              <div className="sa-company-email">{company.email}</div>
            </div>
          </div>
         </td>
         <td>
          <div className="sa-contact-info">
            <div>{company.contact_name || "N/A"}</div>
            <div className="sa-contact-mobile">{company.mobile_no || "N/A"}</div>
          </div>
         </td>
         <td>
          <span className="sa-status-badge" style={{ background: status.bg, color: status.color }}>
            {status.icon} {status.text}
          </span>
         </td>
        <td className="sa-number-cell">{company.actual_pilots || 0}</td>
<td className="sa-number-cell">{company.vehicles || 0}</td>
        <td className="sa-date-cell">{formatDate(company.created_on)}</td>
        <td onClick={(e) => e.stopPropagation()}>
          {getActionButtons(company)}
        </td>
       </tr>
    );
  })}
  {displayedCompanies.length === 0 && (
     <tr>
      <td colSpan="8" className="sa-no-data">
        <div className="sa-no-data-content">
          <span className="sa-no-data-icon">📭</span>
          <h4>No companies found</h4>
          <p>Try adjusting your search or filter criteria</p>
        </div>
      </td>
     </tr>
  )}
</tbody>
          </table>
        </div>
        {hasMoreAdmins && (
          <div className="sa-view-more-container">
            <button 
              className="sa-view-more-btn"
              onClick={() => navigate("/superadmin/view-all-admins")}
            >
              View More Admins ({filteredCompanies.length - 10} more)
              <span className="sa-view-more-arrow">→</span>
            </button>
          </div>
        )}
      </div>

      {showCompanyModal && selectedCompany && (
        <div className="sa-modal-overlay" onClick={() => setShowCompanyModal(false)}>
          <div className="sa-modal-content sa-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="sa-modal-header">
              <div className="sa-modal-header-info">
                {selectedCompany.logo_url ? (
                  <img src={selectedCompany.logo_url} alt={selectedCompany.name} className="sa-modal-logo" />
                ) : (
                  <div className="sa-modal-logo-placeholder">🏢</div>
                )}
                <div>
                  <h2>{selectedCompany.name || "Company Name"}</h2>
                  <p>{selectedCompany.email}</p>
                </div>
              </div>
              <button className="sa-modal-close" onClick={() => setShowCompanyModal(false)}>×</button>
            </div>
            
            <div className="sa-modal-body">
              <div className="sa-profile-section">
                <h3>Company Profile</h3>
                <div className="sa-profile-grid">
                  <div className="sa-profile-item">
                    <span className="sa-profile-label">Contact Person:</span>
                    <span className="sa-profile-value">{selectedCompany.contact_name || "N/A"}</span>
                  </div>
                  <div className="sa-profile-item">
                    <span className="sa-profile-label">Mobile Number:</span>
                    <span className="sa-profile-value">{selectedCompany.mobile_no || "N/A"}</span>
                  </div>
                  <div className="sa-profile-item">
                    <span className="sa-profile-label">Address:</span>
                    <span className="sa-profile-value">{selectedCompany.address || "N/A"}</span>
                  </div>
                  <div className="sa-profile-item">
                    <span className="sa-profile-label">Registered On:</span>
                    <span className="sa-profile-value">{formatDateTime(selectedCompany.created_on)}</span>
                  </div>
                  <div className="sa-profile-item">
                    <span className="sa-profile-label">Status:</span>
                    <span className="sa-profile-value">
                      <span className="sa-status-badge" style={{ 
                        background: getStatusBadge(selectedCompany.approval, selectedCompany.status).bg,
                        color: getStatusBadge(selectedCompany.approval, selectedCompany.status).color
                      }}>
                        {getStatusBadge(selectedCompany.approval, selectedCompany.status).icon} {getStatusBadge(selectedCompany.approval, selectedCompany.status).text}
                      </span>
                    </span>
                  </div>
                  {selectedCompany.gst_url && (
                    <div className="sa-profile-item">
                      <span className="sa-profile-label">GST Certificate:</span>
                      <a href={selectedCompany.gst_url} target="_blank" rel="noopener noreferrer" className="sa-gst-link">
                        View Certificate 📄
                      </a>
                    </div>
                  )}
                </div>
              </div>

             <div className="sa-status-toggle-section">
  <h3>Account Management</h3>
  <div className="sa-toggle-buttons">
    {selectedCompany.approval === 1 && (
      <>
        <button className="sa-btn-approve" onClick={() => {
          setShowCompanyModal(false);
          openActionModal('approve');
        }}>
          ✓ Approve Account
        </button>
        <button className="sa-btn-reject" onClick={() => {
          setShowCompanyModal(false);
          openActionModal('reject');
        }}>
          ✗ Reject Account
        </button>
      </>
    )}
    {selectedCompany.approval === 2 && (
      <button className="sa-btn-reject" onClick={() => {
        setShowCompanyModal(false);
        openActionModal('reject');
      }}>
        ✗ Reject Account
      </button>
    )}
    {selectedCompany.approval === 3 && (
      <button className="sa-btn-approve" onClick={() => {
        setShowCompanyModal(false);
        openActionModal('approve');
      }}>
        ✓ Approve Account
      </button>
    )}
  </div>
</div>

              <div className="sa-fleet-summary">
                <h3>Fleet Summary</h3>
                <div className="sa-fleet-stats">
                  <div className="sa-fleet-stat">
                    <span className="sa-fleet-label">Total Pilots</span>
                    <span className="sa-fleet-value">{companyPilots.length}</span>
                  </div>
                  <div className="sa-fleet-stat">
                    <span className="sa-fleet-label">Total Drones</span>
                    <span className="sa-fleet-value">{selectedCompany.drones || 0}</span>
                  </div>
                  <div className="sa-fleet-stat">
                    <span className="sa-fleet-label">Total Missions</span>
                    <span className="sa-fleet-value">{selectedCompany.total_missions || 0}</span>
                  </div>
                  <div className="sa-fleet-stat">
                    <span className="sa-fleet-label">Acres Sprayed</span>
                    <span className="sa-fleet-value">{selectedCompany.total_acres?.toLocaleString() || 0}</span>
                  </div>
                </div>
              </div>

              <div className="sa-pilots-section">
                <h3>Registered Pilots ({companyPilots.length})</h3>
                {companyPilots.length > 0 ? (
                  <div className="tr-table-container">
                    <table className="tr-table">
                      <thead className="tr-thead">
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th>Registered On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {companyPilots.slice(0, 5).map((pilot, idx) => (
                          <tr key={idx}>
                            <td>{pilot.name}</td>
                            <td>{pilot.email}</td>
                            <td>
                              <span className={`sa-pilot-status ${pilot.status === 1 ? 'active' : 'inactive'}`}>
                                {pilot.status === 1 ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                            <td>{formatDate(pilot.created_on)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {companyPilots.length > 5 && (
                      <div className="sa-view-more">+{companyPilots.length - 5} more pilots</div>
                    )}
                  </div>
                ) : (
                  <p className="sa-no-data-message">No pilots registered</p>
                )}
              </div>

              <div className="sa-admins-section">
                <h3>Company Admins ({companyAdmins.length})</h3>
                {companyAdmins.length > 0 ? (
                  <div className="sa-admins-list">
                    {companyAdmins.map((admin, idx) => (
                      <div key={idx} className="sa-admin-item">
                        <div className="sa-admin-avatar">
                          {admin.name?.charAt(0) || admin.email?.charAt(0) || "A"}
                        </div>
                        <div className="sa-admin-info">
                          <div className="sa-admin-name">{admin.name || "Admin"}</div>
                          <div className="sa-admin-email">{admin.email}</div>
                        </div>
                        <div className="sa-admin-role">Super Admin</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="sa-no-data-message">No admin users found</p>
                )}
              </div>

              <div className="sa-activity-section">
                <h3>Recent Activity</h3>
                {companyActivity.length > 0 ? (
                  <div className="sa-activity-timeline">
                    {companyActivity.map((activity, idx) => (
                      <div key={idx} className="sa-activity-item">
                        <div className="sa-activity-dot"></div>
                        <div className="sa-activity-content">
                          <div className="sa-activity-action">{activity.action}</div>
                          <div className="sa-activity-date">{formatDateTime(activity.date)}</div>
                          <div className="sa-activity-user">by {activity.user}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="sa-no-data-message">No recent activity</p>
                )}
              </div>
            </div>
            
            <div className="sa-modal-footer">
              <button className="sa-modal-close-btn" onClick={() => setShowCompanyModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {showActionModal && selectedCompany && (
        <div className="sa-modal-overlay" onClick={closeActionModal}>
          <div className="sa-modal-content sa-modal-small" onClick={(e) => e.stopPropagation()}>
            <div className="sa-modal-header">
  <h2>
    {actionType === 'approve' && 'Approve Company'}
    {actionType === 'reject' && 'Reject Company'}
  </h2>
  <button className="sa-modal-close" onClick={closeActionModal}>×</button>
</div>
            <div className="sa-modal-body">
              <div className="sa-confirm-container">
                <div className={`sa-confirm-icon sa-confirm-${actionType}`}>
  {actionType === 'approve' && '✓'}
  {actionType === 'reject' && '✗'}
</div>
                <p className="sa-confirm-text">
  Are you sure you want to {actionType} <strong>{selectedCompany.name || selectedCompany.email}</strong>?
</p>
<p className="sa-confirm-subtext">
  {actionType === 'approve' 
    ? 'The company will be able to access the platform and manage their fleet.' 
    : 'The company will be rejected and will not be able to access the platform.'}
</p>
                <div className="sa-confirm-buttons">
                  <button className="sa-confirm-cancel" onClick={closeActionModal} disabled={isUpdating}>
                    Cancel
                  </button>
                 <button 
  className={actionType === 'approve' ? 'sa-confirm-approve' : 'sa-confirm-reject'}
  onClick={() => handleUpdateStatus(actionType)}
  disabled={isUpdating}
>
  {isUpdating ? (
    <>
      <span className="sa-spinner-small"></span>
      Processing...
    </>
  ) : (
    `Yes, ${actionType === 'approve' ? 'Approve' : 'Reject'}`
  )}
</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
    </div>
  );
};

export default SuperAdminDashboard;